import React, {ReactNode} from 'react'
import {ScheduleViewDetailItemBase} from './SchedulesViewDetailItem'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import LocalLaundryServiceOutlinedIcon from '@mui/icons-material/LocalLaundryServiceOutlined'
import {RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import { Typography, Box } from '@mui/material';
import ReservationTimeSettingCleaning, {ReservationTimeSettingCleaningProps} from './ReservationTimeSettingCleaning'
import ReservationTimeSettingMaxReservationTime, {ReservationTimeSettingMaxReservationTimeProps} from './ReservationTimeSettingMaxReservationTime'
import equal from 'fast-deep-equal'

interface Props {
    maxReservationTimeSetting: ReservationTimeSettingMaxReservationTimeProps
    cleaningSetting: ReservationTimeSettingCleaningProps
}

const ReservationTimeSetting: React.FC<Props> = React.memo(props => {

    const spacer: ReactNode = <Box width={'16px'} height={'16px'}/>

    return (
        <Box padding={'3px 3px 3px 8px'}>
            <RowFlexContainer
                style={{paddingLeft: '8px', height: '45px', justifyContent: 'center'}}
            >
                <Typography variant={'caption'}>予約スケジュール</Typography>
            </RowFlexContainer>
            <Box mt={'5px'}/>
            <ScheduleViewDetailItemBase
                icon={<LocalLaundryServiceOutlinedIcon/>}
                action={spacer}
                title={'掃除の時間'}
                detail={
                    <ReservationTimeSettingCleaning
                        {...props.cleaningSetting}
                    />
                }
            />
            <Box mt={'2px'}/>
            <ScheduleViewDetailItemBase
                icon={<AccessTimeIcon/>}
                action={spacer}
                title={'最大予約時間'}
                detail={
                    <ReservationTimeSettingMaxReservationTime
                        {...props.maxReservationTimeSetting}
                    />
                }
            />
        </Box>
    )
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))

ReservationTimeSetting.displayName = 'ReservationTimeSetting'
export default ReservationTimeSetting
